import 'bootstrap/dist/css/bootstrap.min.css'
import {sdk} from './sdk.js';
import {sdkLocal} from './sdkLocal.js';
import './TiktokInterstitialAd.css';
import React, { useState, useEffect, useRef, useCallback } from 'react';
import { AdInterstitial } from './AdInterstitial';

const TiktokInterstitialAd = ({ 
  onAdComplete, 
  onAdSkip, 
  adHeight = 100,
  className = "",
  isVisible = false
}) => {
  const [isAdOpen, setIsAdOpen] = useState(false);
  const [hasShown, setHasShown] = useState(false);
  const [showPlaceholder, setShowPlaceholder] = useState(true);
  const [hasValidAd, setHasValidAd] = useState(null); // null = en cours, true = pub disponible, false = pas de pub
  const containerRef = useRef(null);
  const visibilityTimeoutRef = useRef(null);

  // Style pour ajuster la hauteur du conteneur en fonction de la hauteur de la bannière
  const containerStyle = {
    height: `calc(100vh - ${adHeight}px)`,
  };

  // Démarrer l'interstitiel dès que visible
  useEffect(() => {
    console.log('🎬 TiktokInterstitialAd effect:', { isVisible, hasShown, isAdOpen });
    
    if (isVisible && !hasShown) {
      console.log('✅ Conditions OK pour démarrer interstitiel');
      
      visibilityTimeoutRef.current = setTimeout(() => {
        console.log('🎬 Démarrage publicité interstitielle TikTok');
        setIsAdOpen(true);
        setHasShown(true);
        setShowPlaceholder(false);
      }, 100);
    }

    return () => {
      if (visibilityTimeoutRef.current) {
        clearTimeout(visibilityTimeoutRef.current);
      }
    };
  }, [isVisible, hasShown]);

  // Gestionnaire de fermeture de la pub
  const handleAdClose = useCallback(() => {
    console.log('🎯 Fermeture publicité interstitielle TikTok');
    setIsAdOpen(false);
    
    // Marquer comme terminée seulement si pas de pub valide
    if (hasValidAd === false && onAdComplete) {
      console.log('📭 Pas de publicité disponible - fermeture automatique');
      onAdComplete();
    }
    // Si hasValidAd === true, on ne ferme pas automatiquement, 
    // l'utilisateur peut rester sur la pub jusqu'à ce qu'il scroll
  }, [onAdComplete, hasValidAd]);

  // Callback pour savoir si une pub valide a été chargée
  const handleAdLoadResult = useCallback((hasAd) => {
    console.log('📊 Résultat chargement pub:', hasAd);
    setHasValidAd(hasAd);
    
    // Si pas de pub, fermer automatiquement après un délai
    if (!hasAd) {
      setTimeout(() => {
        handleAdClose();
      }, 1500); // 1.5 secondes pour montrer qu'il n'y a pas de pub
    }
  }, [handleAdClose]);

  // Si pas encore visible
  if (!isVisible && !hasShown) {
    return (
      <div 
        className={`ad-interstitial-video-style ${className}`} 
        style={containerStyle}
        ref={containerRef}
      >
        <div className="ad-interstitial-label">
          Publicité 📱 (En attente)
        </div>
        <div className="ad-interstitial-loading">
          En attente de visibilité...
        </div>
      </div>
    );
  }

  // Si en cours de préparation
  if (isVisible && !isAdOpen && showPlaceholder) {
    return (
      <div 
        className={`ad-interstitial-video-style ${className}`} 
        style={containerStyle}
        ref={containerRef}
      >
        <div className="ad-interstitial-label">
          Publicité 📱 (Chargement)
        </div>
        <div className="ad-interstitial-loading">
          Chargement de la publicité...
        </div>
      </div>
    );
  }

  // Si la pub a été fermée ET qu'il n'y avait pas de pub valide
  if (!isAdOpen && hasShown && hasValidAd === false) {
    // Dans ce cas, on appelle onAdComplete pour faire disparaître complètement cet élément
    // Ceci ne devrait pas s'afficher longtemps car onAdComplete va supprimer cet élément
    return null;
  }

  // Afficher l'interstitiel avec style TikTok
  return (
    <div 
      className={`ad-interstitial-video-style ${className}`} 
      style={containerStyle}
      ref={containerRef}
    >
      <div className="ad-interstitial-label">
        Publicité 📱
      </div>
      
      <AdInterstitial
        zoneId="peupleqc_tiktok_interstitial"
        onClose={handleAdClose}
        showTimer={false} // Pas de timer - on laisse la pub indéfiniment si elle existe
        timerDuration={0}
        autoCloseOnNoAd={true} // Fermer si pas de pub
        onAdLoadResult={handleAdLoadResult} // Nouveau callback pour connaître le résultat
        className=""
        style={{
          position: 'relative',
          width: '100%',
          height: '100%',
          background: 'transparent'
        }}
      />
    </div>
  );
};

export { TiktokInterstitialAd };